// @flow
/*:: import type {ComponentType} from 'react' */
import * as React from 'react'
import Modal from 'react-awesome-modal'
import {translate} from 'react-i18next'
import {
  Button,
  interceptClick,
  Link,
  NavLink
} from 'tutellus-ui'

const {Provider, Consumer} = React.createContext()
const WIPModal /*: ComponentType<{}> */ = translate('wipModal')(({t}) =>
  <Consumer>
    {
      // $FlowFixMe
      ({visible, hide, onClick}) => {
        return <Modal visible={visible} onClickAway={hide}>
          <div style={{padding: '2em', textAlign: 'center', fontWeight: 300}}>
            <p>{t('unavailable_content')}</p>
            <Button primary onClick={onClick}>
              {t('continue_in_spanish')}
            </Button>
          </div>
        </Modal>
      }
    }
  </Consumer>
)
/*::
type clickHandler = void => void
type State = {|
  visible: bool,
  show: clickHandler => void,
  hide: void => void,
  onClick: void => void
|}
type Props = {|children: React.Node|}
*/
export class WIP extends React.Component/*:: <Props, State> */ {
  state = {
    visible: false,
    onClick: () => undefined,
    hide: () =>
      this.setState(currentState => ({
        ...currentState,
        visible: false
      })),
    show: (onClick/*: clickHandler */) =>
      this.setState(currentState => ({
        ...currentState,
        visible: true,
        onClick
      }))
  }
  render () {
    return (
      <Provider value={this.state}>
        {this.props.children}
        <WIPModal />
      </Provider>
    )
  }
}

export const wip = (Component/*: ComponentType<*> */, makeClickHandler/*: any => void => void */) =>
  translate()(({i18n, ...props}/*: any */) => {
    if (i18n.language.startsWith('es')) {
      // $FlowFixMe
      return <Component {...props} />
    }
    const Hijacked = interceptClick(Component)
    return (
      <Consumer>
        {
          // $FlowFixMe
          ({show}) =>
            <Hijacked {...props} intercept={() => show(makeClickHandler(props))} />
        }
      </Consumer>
    )
  })
const visitHref = props => () => (window.location = props.href)
export const WIPLink = wip(NavLink.withComponent('a'), visitHref)
export const WIPButton = wip(Link, visitHref)



// WEBPACK FOOTER //
// ./src/pages/WIPModal.js